import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/lib/util/colors';
import i18n from '@/plugins/vue-i18n';
import OpenAiIcon from '@/components/shared/OpenAiIcon';

Vue.use(Vuetify);

const opts = {
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#D24919',
        secondary: colors.orange.base,
        accent: colors.blue.base,
        error: colors.red.base,
        warning: colors.orange.base,
        info: colors.cyan.base,
        success: colors.green.base
      }
    }
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes,
    values: {
      openai: {
        component: OpenAiIcon,
      },
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
};

export default new Vuetify(opts);